import { Entity } from "@entity/domain/models/entity.model";

/**
 * This class is used to create a new entity just with the name to be used in the user creation.
 */
export class CreateUserEntity {
    constructor(public name: Entity["name"]) {}
}
